// src/pages/Authentication/UserProfile/validationSchema.ts
// Yup validation schema for personal info form

import * as Yup from 'yup';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('authentication');

export const personalInfoSchema = Yup.object().shape({
  fullName: Yup.string()
    .required(st('vui_long_nhap_ho_va_ten_error'))
    .min(3, st('ho_va_ten_phai_co_it_error'))
    .max(100, st('ho_va_ten_khong_duoc_qua_error'))
    .matches(
      /^[a-zA-ZÀ-ỹ\s]+$/,
      st('ho_va_ten_chi_duoc_chua_error')
    ),

  phone: Yup.string()
    .required(st('vui_long_nhap_so_dien_thoai_error'))
    .matches(
      /^0[0-9]{9}$/,
      st('so_dien_thoai_phai_dung_10_error')
    ),

  idCard: Yup.string()
    .required(st('vui_long_nhap_cmnd_cccd_error'))
    .matches(
      /^[0-9]{9,12}$/,
      st('cmnd_cccd_phai_tu_9_12_error')
    ),

  dateOfBirth: Yup.string()
    .required(st('vui_long_nhap_ngay_sinh_error')),

  address: Yup.string()
    .required(st('vui_long_nhap_dia_chi_error'))
    .max(255, st('dia_chi_khong_duoc_qua_255_error')),
});